import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { t } from 'i18next';

import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';
import { getFormTableInitialValues2 } from 'components/BusinessToolForm/utils/helpers';

export const FINANCING_ACTIVITIES_NAMES = {
  TABLE: 'table',
  TOTAL: 'total',
  PROCEEDS_ISSUANCE_DEBT: 'proceedsIssuanceDebt',
  REPAYMENT_DEBT: 'repaymentDebt',
  PROCEEDS_ISSUANCE_EQUITY: 'proceedsIssuanceEquity',
} as const;

export const useGetFinancingActivitiesTableHeadings = () => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const financingActivitiesLinkedFields = {
      [FINANCING_ACTIVITIES_NAMES.PROCEEDS_ISSUANCE_DEBT]: {
        name: '',
        title: t('financialPlan.projectedCashFlow.direct.financingActivities.proceedsIssuanceDebt'),
      },
      [FINANCING_ACTIVITIES_NAMES.REPAYMENT_DEBT]: {
        name: '',
        title: t('financialPlan.projectedCashFlow.direct.financingActivities.repaymentDebt'),
      },
      [FINANCING_ACTIVITIES_NAMES.PROCEEDS_ISSUANCE_EQUITY]: {
        name: '',
        title: t('financialPlan.projectedCashFlow.direct.financingActivities.proceedsIssuanceEquity'),
      },
    };

    const totalRowTitle = t(
      'financialPlan.projectedCashFlow.direct.financingActivities.netCashUsedGeneratedFinancingActivities',
    );

    const financingActivitiesVariants = [
      t('financialPlan.projectedCashFlow.direct.financingActivities.repurchaseCompanyShares'),
      t('financialPlan.projectedCashFlow.direct.financingActivities.dividendsPaid'),
    ];
    return { financingActivitiesLinkedFields, totalRowTitle, financingActivitiesVariants };
  }, [t, i18n]);
};

const financingActivitiesVariants = [
  t('financialPlan.projectedCashFlow.direct.financingActivities.repurchaseCompanyShares'),
  t('financialPlan.projectedCashFlow.direct.financingActivities.dividendsPaid'),
];

export interface IFinancingActivitiesType {
  [FINANCING_ACTIVITIES_NAMES.TABLE]: IPeriodsTableRow[];
  [FINANCING_ACTIVITIES_NAMES.TOTAL]: IPeriodsTableRow;
  [FINANCING_ACTIVITIES_NAMES.PROCEEDS_ISSUANCE_DEBT]: IPeriodsTableRow;
  [FINANCING_ACTIVITIES_NAMES.REPAYMENT_DEBT]: IPeriodsTableRow;
  [FINANCING_ACTIVITIES_NAMES.PROCEEDS_ISSUANCE_EQUITY]: IPeriodsTableRow;
}

export const financingActivitiesInitialValues: IFinancingActivitiesType = {
  [FINANCING_ACTIVITIES_NAMES.TABLE]: getFormTableInitialValues2(
    financingActivitiesVariants.length,
    initialPeriodsTableRow,
  ),
  [FINANCING_ACTIVITIES_NAMES.PROCEEDS_ISSUANCE_DEBT]: initialPeriodsTableRow,
  [FINANCING_ACTIVITIES_NAMES.REPAYMENT_DEBT]: initialPeriodsTableRow,
  [FINANCING_ACTIVITIES_NAMES.PROCEEDS_ISSUANCE_EQUITY]: initialPeriodsTableRow,
  [FINANCING_ACTIVITIES_NAMES.TOTAL]: initialPeriodsTableRow,
};
